import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import Breadcrumbs from "./Breadcrumbs";
import ContactCta from "./ContactCta";

function ProductsLayout() {
	const { pathname } = useLocation();
	const isListing = pathname === "/products";

	return (
		<div>
			<section className="bg-[#F9FAFB] px-4 py-12 sm:px-6 md:px-8 md:py-16">
				<div className="mx-auto max-w-6xl">
					<Breadcrumbs />

					<div className="mt-10 text-center">
						<p className="text-[11px] font-semibold tracking-[0.18em] text-primary sm:text-xs">
							PREMIUM AGRICULTURAL SOLUTIONS
						</p>
						<h1 className="mt-2 font-inter text-[28px] font-bold leading-tight text-[#0f172a] sm:text-4xl md:text-[42px]">
							Our Product Range
						</h1>
						<p className="mx-auto mt-3 max-w-2xl text-sm leading-relaxed text-slate-500 sm:text-[15px] md:text-base">
							Explore our diverse selection of high-quality
							products designed to meet various dairy and
							livestock ventilation needs. Crafted to provide
							exceptional performance.
						</p>
						<div className="mx-auto mt-5 h-[3px] w-12 rounded-full bg-primary"></div>
					</div>

					{isListing && (
						<ContactCta className="mt-8 sm:mt-10" />
					)}

					<div className="mt-8 sm:mt-10">
						<Outlet />
					</div>
				</div>
			</section>

			{isListing && (
				<div className="relative h-[50px] overflow-hidden">
					<div className="flex animate-scroll whitespace-nowrap font-inter">
						{Array.from({ length: 8 }).map((_, index) => (
							<span
								key={index}
								className="bg-[#0c5e99] px-8 py-2.5 text-sm text-white sm:px-[50px] sm:text-lg"
							>
								We also offer Barn Layout and
								Blueprinting!&nbsp;
							</span>
						))}
					</div>
				</div>
			)}
		</div>
	);
}

export default ProductsLayout;
